import {
  ArrowsUpDownIcon,
  BanknotesIcon,
  BellAlertIcon,
  DocumentTextIcon,
  HomeIcon,
  MegaphoneIcon,
  NewspaperIcon,
  PowerIcon,
  RectangleStackIcon,
  RocketLaunchIcon,
  ShoppingCartIcon,
  StopCircleIcon,
  TrophyIcon,
  UserCircleIcon,
  UsersIcon,
  CogIcon,
} from "@heroicons/react/24/outline";
import { TENANT_MODULES } from "../../helpers/tenant-modules";

export const primaryNavItemList = [
  {
    id: 1,
    title: "Dashboard",
    destination: "/",
    Icon: <HomeIcon className="w-4 h-4" />,
  },
  {
    id: 2,
    title: "Offer Products",
    destination: "#",
    moduleKey: TENANT_MODULES.OFFER_PRODUCTS,
    Icon: <ShoppingCartIcon className="w-4 h-4" />,
    children: [
      {
        id: 2,
        title: "List Products",
        destination: "/offer-products",
        Icon: <ShoppingCartIcon className="w-4 h-4" />,
      },
      {
        id: 1,
        title: "Sort Products",
        destination: "/offer-products/sort-order",
        Icon: <ArrowsUpDownIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    id: 3,
    title: "News",
    destination: "/news",
    moduleKey: TENANT_MODULES.NEWS,
    Icon: <NewspaperIcon className="w-4 h-4" />,
  },
  {
    id: 7,
    title: "Promotions",
    destination: "#",
    moduleKey: TENANT_MODULES.CAMPAIGNS,
    Icon: <RocketLaunchIcon className="w-4 h-4" />,
    children: [
      {
        id: 1,
        title: "Campaigns",
        destination: "/coupon-campaign",
        Icon: <MegaphoneIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    id: 4,
    title: "Users",
    destination: "/users",
    Icon: <UsersIcon className="w-4 h-4" />,
  },
  {
    id: 50,
    title: "Invoice Milestones",
    destination: "#",
    moduleKey: TENANT_MODULES.INVOICE_MILESTONE,
    Icon: <TrophyIcon className="w-4 h-4" />,
    children: [
      {
        id: 501,
        title: "Milestones",
        destination: "/invoice-milestone",
        Icon: <StopCircleIcon className="w-4 h-4" />,
      },
      {
        id: 502,
        title: "Invoices",
        destination: "/invoice",
        Icon: <DocumentTextIcon className="w-4 h-4" />,
      },
      {
        id: 503,
        title: "Redeems",
        destination: "/invoice/redeem",
        Icon: <BanknotesIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    id: 10,
    title: "Banners",
    destination: "#",
    Icon: <RectangleStackIcon className="w-4 h-4" />,
    children: [
      {
        id: 8,
        title: "Sliding Banner",
        destination: "/slider",
        Icon: <RectangleStackIcon className="w-4 h-4" />,
      },
      {
        id: 9,
        title: "Promo Banner",
        destination: "/promo-banner",
        Icon: <RectangleStackIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    id: 6,
    title: "Push Notification (Legacy)",
    destination: "/push-notification",
    moduleKey: TENANT_MODULES.PUSH_NOTIFICATIONS,
    Icon: <BellAlertIcon className="w-4 h-4" />,
  },
  {
    id: 60,
    title: "Push Notifications",
    destination: "#",
    moduleKey: TENANT_MODULES.ADVANCED_PUSH_NOTIFICATIONS,
    Icon: <BellAlertIcon className="w-4 h-4" />,
    children: [
      {
        id: 601,
        title: "Compose",
        destination: "/push-notifications/compose",
        Icon: <MegaphoneIcon className="w-4 h-4" />,
      },
      {
        id: 602,
        title: "History",
        destination: "/push-notifications/history",
        Icon: <DocumentTextIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    id: 12,
    title: "My Account",
    destination: "/my-account",
    employeeOnly: true,
    Icon: <UserCircleIcon className="w-4 h-4" />,
  },
  {
    id: 11,
    title: "Employees",
    destination: "/employees",
    adminOnly: true,
    Icon: <UsersIcon className="w-4 h-4" />,
  },
];

export const bottomNavItemList = [
  {
    id: 51,
    title: "Configure",
    destination: "/settings",
    adminOnly: true,
    Icon: <CogIcon className="w-4 h-4" />,
  },
  {
    id: 5,
    title: "Logout",
    destination: "/logout",
    Icon: <PowerIcon className="w-4 h-4" />,
  },
];
